export default __webpack_public_path__ + "static/media/17.548fef1d.png";